import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { tap } from 'rxjs';
import { injectPartnerWebUrl } from '../../providers/partner-web-url.token';
import { isHWS } from '../../providers/platform.token';
import { injectVehicleMarketUrl } from '../../providers/vehicle-market-url.token';

@Injectable()
export class SeoEffects {
    protected readonly actions$ = inject(Actions);
    protected readonly doc = inject(DOCUMENT);
    protected readonly vehicleMarketUrl = injectVehicleMarketUrl();
    protected readonly partnerWebUrl = injectPartnerWebUrl();
    protected readonly isPartnerWeb = isHWS();

    initCanonical = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(ROUTER_NAVIGATED),
                tap(() => {
                    const link = this.doc.querySelector("link[rel='canonical']") ?? this.createLink();
                    link.setAttribute(
                        'href',
                        `${this.isPartnerWeb ? this.partnerWebUrl : this.vehicleMarketUrl}${this.doc.location.pathname}`,
                    );
                }),
            );
        },
        { dispatch: false },
    );

    private createLink() {
        const link = this.doc.createElement('link');
        link.setAttribute('rel', 'canonical');
        this.doc.head.appendChild(link);
        return link;
    }
}
